import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useBillingCycleState } from "@/react/hooks/useBillingCycleState";
import { BillingCycleLink } from "./BillingCycleLink";

export const BillingCycle = () => {
  const { shouldShowBillingCycleOptions, planIntervals, isSelected } =
    useBillingCycleState();

  return shouldShowBillingCycleOptions ? (
    <div>
      <div
        className={classNames(
          "bg-secondary mt-0 flex w-full flex-row space-x-1 rounded-lg p-1 text-sm",
        )}
      >
        <BillingCycleLink
          interval={planIntervals.year}
          isSelected={isSelected}
          label={t("pricing_plans.billing_cycle.annually")}
        />
        <BillingCycleLink
          interval={planIntervals.month}
          isSelected={isSelected}
          label={t("pricing_plans.billing_cycle.monthly")}
        />
      </div>
    </div>
  ) : (
    <div />
  );
};
